// ----------------------------------------------------------------------

export default function DataGrid(theme) {
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    height: 410,
                    minWidth: 430,
                    border: `1px solid transparent`,
                    '& .MuiTablePagination-root': {
                        borderTop: 7,
                       // display: 'none',
                        '& .MuiTablePagination-toolbar': {
                            height: 45,
                            minHeight: 35,
                            paddingLeft: 0,
                        },
                    },
                    '.MuiDataGrid-columnSeparator': {
                        display: 'none',
                    },
                    '.MuiDataGrid-cell:focus-within': {
                        outline: 'none',
                    },
                    '.MuiDataGrid-cell': {
                        borderBottom: 'none',
                    },
                },
                cell: {
                    borderBottom: `1px solid ${theme.palette.divider}`,
                },
                columnSeparator: {
                    color: theme.palette.divider,
                },
                columnHeader: {
                    //   backgroundColor: theme.palette.grey[100],
                    paddingLeft: theme.spacing(2),
                   
                },
                columnHeaders: {
                    backgroundColor: theme.palette.grey[300],
                    color: '#3b3c78',
                     height: '12%',
                    // minHeight: '0px !important'
                },
                row: {
                    '&:hover': {
                        backgroundColor: theme.palette.grey[100],
                    },
                   // paddingLeft: theme.spacing(2),
                    
                    paddingBottom: theme.spacing(2),
                   
                },
                toolbarContainer: {
                    padding: '8px',
                    backgroundColor: theme.palette.background.default,
                    '& .MuiButton-root': {
                        marginRight: theme.spacing(1),
                        color: theme.palette.text.primary,
                        '&:hover': {
                            backgroundColor: theme.palette.action.hover,
                        },
                    },
                },
                paper: {
                    boxShadow: theme.customShadows.dropdown,
                },
                menu: {
                    '& .MuiPaper-root': {
                        boxShadow: theme.customShadows.dropdown,
                    },
                    '& .MuiMenuItem-root': {
                        ...theme.typography.body2,
                        '& .MuiListItemIcon-root': {
                            minWidth: 'auto',
                        },
                    },
                },
                 panelFooter: {
                    padding: theme.spacing(0),
                    justifyContent: 'flex-end',
                    borderTop: `1px solid ${theme.palette.divider}`,
                    '& .MuiButton-root': {
                        '&:first-of-type': {
                            marginRight: theme.spacing(1.5),
                            color: theme.palette.text.primary,
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover,
                            },
                        },
                        '&:last-of-type': {
                            color: theme.palette.common.white,
                            backgroundColor: theme.palette.primary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.primary.dark,
                            },
                        },
                    },
                 },
                filterForm: {
                    padding: theme.spacing(1.5, 0),
                    width: 360,
                    '& .MuiFormControl-root': {
                        margin: theme.spacing(0, 0.5),
                    },
                    '& .MuiInput-root': {
                        marginTop: theme.spacing(0),
                        '&::before, &::after': {
                            display: 'none',
                        },
                        '& .MuiNativeSelect-select, .MuiInput-input': {
                            ...theme.typography.body2,
                            padding: theme.spacing(0.75, 1),
                            borderRadius: theme.shape.borderRadius,
                            backgroundColor: theme.palette.background.neutral,
                        },
                        '& .MuiSvgIcon-root': {
                            right: 4,
                        },
                    },
                },
                footerContainer: {
                    height: 10,
                    minHeight: 20,
                },
            },
        },
    };
}
